import React, { useEffect } from 'react'

// const { Footer, Content } = Layout;

export default ({ children }:any) => {
  
  return (
    <div style={{ height: '100%' }}>
      { children }
    </div>
  )
}
